export enum ItemStatusIndicator {
    DELETED = 'Deleted',
    ARCHIVED ='Archived',
    TEMPLATE = 'Template',
    PUBLISHED = 'Published',
    PREVIEW = 'Preview',
    DRAFT = 'Draft'
}
